import { render, staticRenderFns } from "./bo-empty-cart.vue?vue&type=template&id=07900e80"
import script from "./bo-empty-cart.vue?vue&type=script&lang=js"
export * from "./bo-empty-cart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports